import { Languages } from '../types/languages';

export const LANGUAGES: Languages = {
  lt: { short: 'LT', nativeName: 'Lietuvių' },
  en: { short: 'EN', nativeName: 'English' },
};
